define('models/widgets/account',['require','models/base/model','models/base/widget','models/base/sync-collection'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        Widget = require('models/base/widget'),
        SyncCollection = require('models/base/sync-collection');

    var Account = Model.extend({

    });

    var AccountCollection = SyncCollection.extend({
        model: Account
    });

    var AccountWidget = Widget.extend({
        action: 'widget.accounts',
        collectionClass: AccountCollection,
        parse: function(data) {
            this.items.set(data.items);
            return data;
        }
    });

    return AccountWidget;
});
